/**
 * Variant URL Handler
 * 
 * This module checks if there's a variant ID in the URL when a product page loads.
 * If found, it finds and selects the corresponding variant, showing its image.
 */

const VariantURLHandler = (function() {
  function init() {
    // Only run on product pages
    if (!document.querySelector('.template-product')) {
      return;
    }

    // Get the variant from URL if present
    const variantId = getUrlParameter('variant');
    if (!variantId) {
      // If no variant in URL, show the default product image
      // No need to do anything, the theme will handle it
      return;
    }

    // Find and trigger the variant selection
    selectVariantFromId(variantId);
  }

  /**
   * Get URL parameter by name
   */
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  /**
   * Select variant with the given ID
   */
  function selectVariantFromId(variantId) {
    const variantSelectors = document.querySelectorAll('[data-variant-input]');
    const form = document.querySelector('.product-single__form');
    
    if (!form || !variantSelectors.length) {
      console.warn('Variant URL Handler: Form or variant selectors not found');
      return;
    }

    // Find the original product select element that contains all variants
    const productSelect = form.querySelector('[data-product-select]');
    if (!productSelect) {
      console.warn('Variant URL Handler: Product select not found');
      return;
    }

    // Find the variant data
    let variantData = null;
    try {
      const variantJson = document.querySelector('[data-variant-json]');
      if (variantJson) {
        const variants = JSON.parse(variantJson.innerHTML);
        variantData = variants.find(variant => variant.id.toString() === variantId.toString());
      }
    } catch (e) {
      console.error('Variant URL Handler: Error parsing variant JSON', e);
      return;
    }

    if (!variantData) {
      console.warn(`Variant URL Handler: Variant with ID ${variantId} not found`);
      return;
    }

    // For each option (e.g., "Color", "Size"), find and select the correct value
    const optionSelectors = {};
    variantSelectors.forEach(selector => {
      const optionIndex = selector.dataset.index;
      const optionValue = selector.value;
      
      // Group selectors by their option index (option1, option2, etc.)
      if (!optionSelectors[optionIndex]) {
        optionSelectors[optionIndex] = [];
      }
      optionSelectors[optionIndex].push(selector);
    });

    // Now select each option based on the variant data
    Object.keys(optionSelectors).forEach(optionIndex => {
      const optionValue = variantData[optionIndex];
      const selectors = optionSelectors[optionIndex];
      
      // Find the selector with the matching value
      const matchingSelector = selectors.find(selector => {
        // For radio buttons and checkboxes
        if (selector.type === 'radio' || selector.type === 'checkbox') {
          return selector.value === optionValue;
        }
        // For select dropdowns
        return selector.querySelector(`option[value="${optionValue}"]`);
      });
      
      if (matchingSelector) {
        if (matchingSelector.type === 'radio' || matchingSelector.type === 'checkbox') {
          matchingSelector.checked = true;
          // Trigger change event
          matchingSelector.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // For select dropdowns
          matchingSelector.value = optionValue;
          // Trigger change event
          matchingSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // After selecting all options, make sure our variant is selected in the main dropdown
    if (productSelect) {
      productSelect.value = variantId;
      // Force a change event so the variant change event fires properly
      productSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /**
   * Select the cheapest available variant when no variant is specified
   */
  function selectCheapestVariant() {
    try {
      const variantJson = document.querySelector('[data-variant-json]');
      if (!variantJson) return;
      
      const variants = JSON.parse(variantJson.innerHTML);
      
      // Find cheapest available variant
      const availableVariants = variants.filter(variant => variant.available);
      if (!availableVariants.length) return;
      
      const cheapestVariant = availableVariants.reduce((prev, current) => 
        (prev.price < current.price) ? prev : current
      );
      
      if (cheapestVariant) {
        selectVariantFromId(cheapestVariant.id);
      }
    } catch (e) {
      console.error('Error selecting cheapest variant:', e);
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API
  return {
    init: init,
    selectVariantFromId: selectVariantFromId
  };
})();
